import Swiper from 'swiper';
import SwiperCore, { Navigation, EffectFade, Pagination } from 'swiper/core';

SwiperCore.use( [Navigation, EffectFade, Pagination] );

export class Carousel {

    constructor ( target = '.js-carousel', options = {} ) {

        this.target = target;


        this.options = {
            spaceBetween: 0,
            slidesPerView: 1,
            touchEventsTarget: 'wrapper',
            slideClass: 'js-carousel__item',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__item--active',
            noSwipingClass: 'js-carousel__no-swipe',
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init () {

        this.carousels = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );


        if ( this.el.length > 0 ) {
            this.carouselObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this )
            }, this.options );

            this.el.forEach( $el => {
                this.carouselObserver.observe( $el );
            } );
        }

    }

    create ( entries, instance ) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {

                const $el = entry.target;

                const $container = $el.querySelector('.js-carousel__container') ?? $el;

                const count = Array.from( $el.querySelectorAll( `.${this.options.slideClass}` ) ).length;

                const slidesPerView = $el.dataset.show ?? 1;

                let options = {
                    ...this.options,
                    slidesPerView
                }

                const $controls = $el.querySelector( `.js-carousel__controls` );

                if ( count > 1 ) {
                    if ( $controls ) {
                        options = {
                            ...options,
                            navigation: {
                                nextEl: $el.querySelector( '.js-carousel__button--next' ),
                                prevEl: $el.querySelector( '.js-carousel__button--prev' ),
                                disabledClass: 'js-carousel__button--disabled'
                            },
                        }
                    }
                } else {

                    if ( $controls ) {
                        $controls.remove();
                    }
                }

                const $pagination = $el.querySelector( `.js-carousel__pagination` );

                if($pagination) {
                    options = {
                        ...options,
                        pagination: {
                            el: $pagination,
                            clickable: true,
                            renderBullet: function( index, className ) {

                                const attr = `data-timeline-${index + 1}`;
                                const $item = document.querySelector(`[${attr}]`);

                                const dataset = `timeline-${index + 1}`;
                                const year = $item.dataset[dataset];
                                return `<div class="c-timeline-pagination__item ${className}"><span class="c-pagination-timeline__item-circle"></span><span class="c-pagination-timeline__item-text">${year}</span></div>`;
                            },
                        },
                    }
                }

                if($el.dataset.spaceBetween) {
                    options = {
                        ...options,
                        spaceBetween: parseInt($el.dataset.spaceBetween)
                    }
                }

                if ( $el.dataset.transition == 'fade' ) {
                    options = {
                        ...options,
                        spaceBetween: 0,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                    }
                }

                const carousel = new Swiper( $container, options );

                if(options.effect != 'fade') {
                    carousel.on( 'slideChange', ( swiper ) => {
                        if(swiper.$el) {
                            if ( swiper.realIndex >= 1 ) {
                                swiper.$el.addClass( 'js-carousel--active' );
                            } else {
                                swiper.$el.removeClass( 'js-carousel--active' );
                            }
                        }
                    } )
                }

                const $reset = $el.querySelector( `.js-carousel__button-reset` );

                if ( $reset ) {
                    $reset.addEventListener( 'click', () => {
                        carousel.slideTo( 0, 1000 );
                    } )
                }

                this.carousels.push( carousel );
                instance.carouselObserver.unobserve( entry.target );
            }
        } )
    }
}
